import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Marketplaces from "@/pages/Marketplaces";
import PremiumMarketplaces from "@/pages/PremiumMarketplaces";
import QuickCommerce from "@/pages/QuickCommerce";
import WebAppDev from "@/pages/WebAppDev";
import CrmSolutions from "@/pages/CrmSolutions";
import ManpowerSolutions from "@/pages/ManpowerSolutions";
import GoogleExtractor from "@/pages/GoogleExtractor";
import Calculators from "@/pages/Calculators";
import TestimonialsPage from "@/pages/TestimonialsPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";
import NotFound from "@/pages/NotFound";
import MarketplaceServicePage from "@/pages/MarketplaceServicePage";
import APlusListingGraphics from "@/pages/APlusListingGraphics";
import EcommerceVideoCreation from "@/pages/EcommerceVideoCreation";
import SalesEvents from "@/pages/SalesEvents";
import MarketplaceCalculatorHub from "@/pages/MarketplaceCalculatorHub";
import ListingScoreTool from "@/pages/ListingScoreTool";
import About from "@/pages/About";
import MarketPage from "@/pages/MarketPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/ecommerce-services-usa" element={<MarketPage market="usa" />} />
              <Route path="/ecommerce-services-uae" element={<MarketPage market="uae" />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/a-plus-listing-graphics" element={<APlusListingGraphics />} />
              <Route path="/services/ecommerce-video-creation" element={<EcommerceVideoCreation />} />
              <Route path="/services/:slug" element={<MarketplaceServicePage />} />
              <Route path="/tools/marketplace-calculators" element={<MarketplaceCalculatorHub />} />
              <Route path="/tools/listing-score" element={<ListingScoreTool />} />
              <Route path="/sales-events" element={<SalesEvents />} />
              <Route path="/marketplaces" element={<Marketplaces />} />
              <Route path="/premium-marketplaces" element={<PremiumMarketplaces />} />
              <Route path="/quick-commerce" element={<QuickCommerce />} />
              <Route path="/web-app-development" element={<WebAppDev />} />
              <Route path="/crm-solutions" element={<CrmSolutions />} />
              <Route path="/manpower-solutions" element={<ManpowerSolutions />} />
              <Route path="/google-extractor" element={<GoogleExtractor />} />
              <Route path="/calculators" element={<Calculators />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              border: "2px solid #000",
              borderRadius: "0px",
              fontFamily: "Cabinet Grotesk, sans-serif",
              fontWeight: 700,
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
